import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Owners_ds_get_container_types_by_Id_top1Service {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { Id: number }): 
  Promise<{ result: { Id?: number, CatchAll?: boolean, Description?: string, Height?: number, Length?: number, Name?: string, WeightCapacity?: number, Width?: number, DimensionUom?: { Short_name?: string }, WeightUom?: { Short_name?: string } } }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.Id)) {
      missingRequiredInParams.push('\'Id\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Owners/datasources/ds_get_container_types_by_Id_top1/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      Id: number    }) {
        if(isNil(inParams.Id)) {
          return true; 
        }
      return false;
    }
}
